export function initHiddenImages(containerEl) {
  const hiddenImagesEl = document.querySelector('.js-hidden-images-container')
  const showBtn = document.querySelector('.js-hidden-images-show-btn')

  if (hiddenImagesEl && showBtn) {
    showBtn.addEventListener('click', () => {
      containerEl.append(...hiddenImagesEl.childNodes)
      showBtn.remove()
    })
  }
}